import TitleCard from "./ui/TitleCard";
import React from "react";
import UnifiedCard from "./ui/UnifiedCard";

const ProductCategory = ({ products, categoryTitle }) => {
    return (
        <>
            <TitleCard>
                <span className="text-ink">My </span>
                <span className="font-brand-primary text-terra">{categoryTitle}</span>
            </TitleCard>

            {/* Horizontal scrolling container */}
            <div className="relative w-full overflow-x-auto no-scrollbar">
                <div className="flex gap-4 px-6 pb-6">
                    {products.map((product, index) => (
                        <UnifiedCard
                            key={index}
                            status={product.brand}
                            name={product.title}
                            description={product.why || product.altText || ''}
                            link={product.link}
                            imageUrl={product.imageUrl}
                            affiliateCode={product.affiliateCode}
                            linkLabel="Shop Now"
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default ProductCategory;
